import usePremiumResource from "./usePremiumResource";

/** Pobiera wpisy wybranego słownika tylko dla użytkownika z prawem edycji. */
export default function useDictionaryFormData(organization, token, kind) {
  const url = `/organizations/${organization.id}/dictionaries`;
  const resource = usePremiumResource(
    token,
    organization.manageDictionaries ? url : null,
  );
  return {
    ...resource,
    url,
    entries: (resource.data?.entries || []).filter(
      (entry) => entry.kind === kind,
    ),
    accessError: organization.manageDictionaries
      ? ""
      : "Nie masz uprawnień do edycji słowników tej firmy.",
  };
}
